<template>
  <div id="container">
    <div id="op-controls" class="control-group-container">
      <div class="control-group__title">When opposition has the ball...</div>

      <div class="control__subgroup-title">Trigger press</div>
      <GradedPISelector 
        :selectedValue="fetchValue('pressingIntensity')"
        :maxValue="anyPartOfRole('pressingIntensity') ? fetchValue('pressingIntensity') : 1"
        :minValue="anyPartOfRole('pressingIntensity') ? fetchValue('pressingIntensity') : -1"
        :partOfRole="anyPartOfRole('pressingIntensity')"
        @update:value="setInstruction('pressingIntensity', $event)">
          {{ $t(pressingIntensityKey) }}
      </GradedPISelector>

      <div class="control-container">
        <div 
          @click="toggleInstruction('marking', 1)"
          :class="['control-btn', independentInstructionStyleObject('marking', 1)]">
            Mark tighter
        </div>
      </div>

      <div class="control__subgroup-title">Tackling</div>
      <div class="control-container">
        <div 
          @click="toggleInstruction('tackling', 1)"
          :class="['control-btn', conflictingInstructionStyleObject('tackling', 1)]">
            Tackle Harder
        </div>
      </div>
      <div class="control-container">
        <div 
          @click="toggleInstruction('tackling', -1)"
          :class="['control-btn', conflictingInstructionStyleObject('tackling', -1)]">
            Ease off tackles
        </div>
      </div>
    </div>
    
    <div id="tp-controls" class="control-group-container">
      <div class="control-group__title">When team has the ball...</div>
      <div class="control-container">
        <div 
          @click="toggleInstruction('getFurtherForward', 1)"
          :class="['control-btn', independentInstructionStyleObject('getFurtherForward', 1)]">
            Get further forward
        </div>
      </div>
      <div class="control-container">
        <div 
          @click="toggleInstruction('attackingWidth', 1)"
          :class="['control-btn', conflictingInstructionStyleObject('attackingWidth', 1)]">
            Stay wider
        </div>
      </div>
      <div class="control-container">
        <div 
          @click="toggleInstruction('attackingWidth', -1)"
          :class="['control-btn', conflictingInstructionStyleObject('attackingWidth', -1)]">
            Sit narrower
        </div>
      </div>

      <div class="control__subgroup-title">Freedom of movement</div>
      <div class="control-container">
        <div 
          @click="toggleInstruction('movement', -1)"
          :class="['control-btn', conflictingInstructionStyleObject('movement', -1)]">
            Hold position
        </div>
      </div>
      <div class="control-container">
        <div 
          @click="toggleInstruction('movement', 1)"
          :class="['control-btn', conflictingInstructionStyleObject('movement', 1)]">
            Roam from position
        </div>
      </div>
    </div>
    <div id="sp-controls" class="control-group-container control-group__container--columns">
      <div class="control-group__title">When player has the ball...</div>
      <div class="control-group__column">
        <div class="control-container">
          <div 
            @click="toggleInstruction('lateralDribbling', -1)"
            :class="['control-btn', conflictingInstructionStyleObject('lateralDribbling', -1)]">
              Run wide with ball
          </div>
        </div>
        <div class="control-container">
          <div 
            @click="toggleInstruction('lateralDribbling', 1)"
            :class="['control-btn', conflictingInstructionStyleObject('lateralDribbling', 1)]">
              Cut inside with ball
          </div>
        </div>
        <div class="control-container">
          <div 
            @click="toggleInstruction('holdUpBall', 1)"
            :class="['control-btn', independentInstructionStyleObject('holdUpBall', 1)]">
              Hold up ball
          </div>
        </div>

        <div class="control__subgroup-title">Passing Directness</div>
        <GradedPISelector 
          :selectedValue="fetchValue('passingDirectness')"
          :maxValue="anyPartOfRole('passingDirectness') ? fetchValue('passingDirectness') : 1"
          :minValue="anyPartOfRole('passingDirectness') ? fetchValue('passingDirectness') : -1"
          :partOfRole="anyPartOfRole('passingDirectness')"
          @update:value="setInstruction('passingDirectness', $event)">
            {{ $t(passingDirectnessKey) }}
        </GradedPISelector>

        <div class="control__subgroup-title">Cross from</div>
        <div class="control-container">
          <div 
            @click="toggleInstruction('crossingPosition', 1)"
            :class="['control-btn', conflictingInstructionStyleObject('crossingPosition', 1)]">
              Cross from deep
          </div>
        </div>
        <div class="control-container">
          <div 
            @click="toggleInstruction('crossingPosition', -1)"
            :class="['control-btn', conflictingInstructionStyleObject('crossingPosition', -1)]">
              Cross from byline
         </div>
        </div>

        <div class="control__subgroup-title">Crossing frequency</div>
        <div class="control-container">
          <div 
            @click="toggleInstruction('crossingFrequency', 1)"
            :class="['control-btn', conflictingInstructionStyleObject('crossingFrequency', 1)]">
              Cross more often
          </div>
        </div>
        <div class="control-container">
          <div 
            @click="toggleInstruction('crossingFrequency', -1)"
            :class="['control-btn', conflictingInstructionStyleObject('crossingFrequency', -1)]">
              Cross less often
          </div>
        </div>
      </div>

      <div class="control-group__column">
        <div class="control__subgroup-title">Dribbling</div>
        <div class="control-container">
          <div 
            @click="toggleInstruction('dribbling', 1)"
            :class="['control-btn', conflictingInstructionStyleObject('dribbling', 1)]">
              Dribble more
          </div>
        </div>
        <div class="control-container">
          <div 
            @click="toggleInstruction('dribbling', -1)"
            :class="['control-btn', conflictingInstructionStyleObject('dribbling', -1)]">
            Dribble less
        </div>
        </div>

        <div class="control__subgroup-title">Shooting</div>
        <div class="control-container">
          <div 
            @click="toggleInstruction('shooting', 1)"
            :class="['control-btn', conflictingInstructionStyleObject('shooting', 1)]">
              Shoot more often
          </div>
        </div>
        <div class="control-container">
          <div 
            @click="toggleInstruction('shooting', -1)"
            :class="['control-btn', conflictingInstructionStyleObject('shooting', -1)]">
              Shoot less often
          </div>
        </div>

        <div class="control__subgroup-title">Passing risks</div>
        <div class="control-container">
          <div 
            @click="toggleInstruction('passingRisks', 1)"
            :class="['control-btn', conflictingInstructionStyleObject('passingRisks', 1)]">
              Take more risks
          </div>
        </div>
        <div class="control-container">
          <div 
            @click="toggleInstruction('passingRisks', -1)"
            :class="['control-btn', conflictingInstructionStyleObject('passingRisks', -1)]">
              Take fewer risks
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GradedPISelector from "@/components/GradedPISelector";

export default {
  components: {GradedPISelector},

  props: {
    position: Object,
  },

  computed: {
    setInstructions() {
      return this.$store.getters.positionPlayerInstructions(this.position.positionNumber);
    },

    passingDirectnessKey() {
      const keys = {
        "1": "more",
        "0": "neutral",
        "-1": "less"
      }
      const value = this.fetchValue('passingDirectness').toString();
      
      return `tactics.pis.passingDirectness.${keys[value]}`
    },

    pressingIntensityKey() {
      const keys = {
        "1": "more",
        "0": "neutral",
        "-1": "less"
      }
      const value = this.fetchValue('pressingIntensity').toString();
      
      return `tactics.pis.pressingIntensity.${keys[value]}`
    }
  },

  methods: {
    fetchValue(key) {
      const object = this.setInstructions.find((instruction) => {
        return instruction.name === key;
      })
      if (object === undefined) return 0;
      return object.value;
    },

    partOfRole(key, value) {
      const object = this.setInstructions.find((instruction) => {
        return instruction.name === key;
      })
      if (object === undefined) return false;
      return object.partOfRole && object.value === value;
    },

    anyPartOfRole(key) {
      const object = this.setInstructions.find((instruction) => {
        return instruction.name === key && instruction.partOfRole;
      });
      return object !== undefined;
    },

    selected(key, value) {
      const object = this.setInstructions.find((instruction) => {
        return instruction.name === key;
      })
      if (object === undefined) return false;
      return object.partOfRole === false && object.value === value;
    },

    conflicting(key, value) {
      const object = this.setInstructions.find((instruction) => {
        return instruction.name === key;
      })
      if (object === undefined) return false;
      return object.value !== value && object.value !== 0;
    },

    toggleInstruction(key, onValue) {
      const currentStatus = this.setInstructions.find(instruction =>  instruction.name === key);
      if (currentStatus?.partOfRole) return;
      this.$store.commit('setCustomInstruction', { 
        position: 'player'+this.position.positionNumber, 
        instructionKey: key, 
        instructionValue: (currentStatus === undefined || currentStatus.value !== onValue) ? onValue : 0,
      });
    },

    setInstruction(key, value) {
      this.$store.commit('setCustomInstruction', {
        position: 'player'+this.position.positionNumber, 
        instructionKey: key, 
        instructionValue: value,
      });
    },

    independentInstructionStyleObject(key, value) {
      return {
        'instruction--part-of-role': this.partOfRole(key, value), 
        'instruction--selected': this.selected(key, value),
      };
    },

    conflictingInstructionStyleObject(key, value) {
      return {
        'instruction--part-of-role': this.partOfRole(key, value),
        'instruction--selected': this.selected(key, value),
        'control-btn--disabled': this.partOfRole(key, value * (-1)),
        'control-btn--conflicting': this.conflicting(key, value)
      };
    }
  }
}
</script>

<style scoped>
  #container {
    flex: 1;
    display: flex;
    padding-bottom: 16px;
  }

  .control-group-container {
    height: 100%;
    display: inline-block;
  }

  .control-group-container, .control-group__column {
    padding: 0 12px;
  }

  .control-group__container--columns {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding: 0;
  }

  #op-controls, #tp-controls {
    width: 25%;
  }

  #sp-controls {
    width: 50%;
  }

  .control-group__title {
    text-transform: uppercase;
    opacity: 0.55;
    font-weight: bold;
    font-size: small;
    width: 100%;
    height: 24px;
    padding: 0 4px;
  }

  .control-group__column {
    flex: 1;
  }

  .control__subgroup-title {
    text-transform: uppercase;
    font-weight: bold;
    font-size: small;
    width: 100%;
    height: 24px;
    margin: 12px 0 -4px;
  }

  .control-container {
    width: 100%;
    margin: 4px 0;
  }

  .control-btn {
    padding: 4px 12px;
    border-radius: 8px;
    text-align: center;
    border: solid 2px white;
    cursor: pointer;
    text-transform: capitalize;
    transition: 0.3s;
  }

  .control-btn:hover {
    background: rgba(255, 255, 255, 0.12);
  }

  .control-btn--disabled {
    opacity: 0.55;
    cursor: default;
  }

  .control-btn--disabled:hover, .instruction--part-of-role:hover {
    background: none;
  }

  .instruction--part-of-role {
    border-color: #89DB2C;
    opacity: 0.55;
    cursor: default;
  }

  .instruction--selected {
    border-color: #03A93C;
  }

  .instruction--selected:hover {
    background: rgba(137, 219, 44, 0.12);
  }

  .control-btn--conflicting {
    border-color: #F65E4F;
  }

  .control-btn--conflicting:hover {
    background: rgba(246, 94, 79, 0.12);
  }
</style>
